import { SubjectKey } from "../../../Concepts.interface";

const SUBJECT_TO_TAB_MAP: Record<string, SubjectKey> = {
  "english-arts-reading": "ela",
  "social-studies": "socialStudies",
  science: "science",
};

const SUBJECT_PRIORITY: SubjectKey[] = ["ela", "socialStudies", "science"];

const DEFAULT_SUBJECT = SUBJECT_PRIORITY[0]!;

export const getDefaultTabId = (userSubjects?: string[]): SubjectKey => {
  if (!userSubjects?.length) return DEFAULT_SUBJECT;

  const matchedTabs = new Set(
    userSubjects
      .map((s) => SUBJECT_TO_TAB_MAP[s.toLowerCase()])
      .filter((tab): tab is SubjectKey => Boolean(tab)),
  );

  if (matchedTabs.size === 1) return [...matchedTabs][0]!;

  // Multiple subjects or no match: follow priority ELA > SS > Science
  return (
    SUBJECT_PRIORITY.find((tab) => matchedTabs.has(tab)) ?? DEFAULT_SUBJECT
  );
};
